import { Stack } from '@mui/system';
import { Dispatch, SetStateAction } from 'react';
import CompanyAwardsEditModal from './components/CompanyAwardsEditModal';
import CustomChip from '../../../../../../../../../components/custom-chip/CustomChip';
import { truncate } from '../../../../../../../../../utils/helpers';
import useUserCompany from '../../../../../../../../../utils/hooks/useUserCompany';
import { CHIP_LABEL_TRUNCATE_VALUE } from '../../../../../../../../../utils/constants';

interface CompanyAwardsProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyAwards = ({ isEditModalOpen, setIsEditModalOpen }: CompanyAwardsProps) => {
  const { company: companyData } = useUserCompany();

  return (
    <Stack
      direction="row"
      gap={1}
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {companyData?.awards?.map((award: string) => (
        <CustomChip
          key={award}
          tooltipTitle={award}
          label={award && truncate(award as string, CHIP_LABEL_TRUNCATE_VALUE as number)}
          sx={{
            width: 'fit-content',
            textTransform: 'capitalize',
          }}
        />
      ))}

      {companyData && (
        <CompanyAwardsEditModal
          isEditModalOpen={isEditModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
        />
      )}
    </Stack>
  );
};

export default CompanyAwards;
